import { Job } from '../types/job';

export const jobs: Job[] = [
  {
    id: 'charge-projet',
    title: 'Chargé(e) de Projet',
    department: 'Projets',
    type: 'Bénévole',
    location: 'Hybride',
    commitment: '8-10 heures par semaine',
    description: "Nous recherchons un(e) chargé(e) de projet motivé(e) pour imaginer, lancer et piloter de nouveaux projets au service des étudiants.",
    responsibilities: [
      "Identifier les besoins des étudiants et proposer de nouveaux projets",
      "Définir les objectifs, le planning et les ressources de chaque projet",
      "Coordonner les équipes (développement, design, partenariats)",
      "Suivre l'avancement et assurer le respect des délais",
      "Présenter les résultats et proposer des axes d'amélioration"
    ],
    requirements: [
      "Être majeur(e) (18 ans ou plus)",
      "Étudiant(e) en gestion de projet, école de commerce, d'ingénieur ou domaine connexe",
      "Sens de l'organisation et autonomie",
      "Excellentes capacités de communication",
      "Esprit d'initiative et force de proposition"
    ],
    skills: {
      required: [
        "Gestion de Projet",
        "Organisation",
        "Communication",
        "Travail en équipe"
      ],
      preferred: [
        "Méthodes Agiles",
        "Notion / Trello",
        "Expérience associative",
        "Connaissance du secteur EdTech"
      ]
    }
  },
  {
    id: 'developpeur-web',
    title: 'Développeur(se) Web & Backend',
    department: 'Technique',
    type: 'Bénévole',
    location: 'Remote',
    commitment: '8-10 heures par semaine',
    description: "Nous recherchons des développeur(se)s web et backend pour concevoir, développer et maintenir les applications et services de l'association.",
    responsibilities: [
      "Développer de nouvelles fonctionnalités sur nos applications web",
      "Concevoir et maintenir des API et services backend",
      "Participer aux choix techniques et à l'architecture des projets",
      "Garantir la qualité du code (revues de code, tests)",
      "Collaborer avec les designers et les chargé(e)s de projet"
    ],
    requirements: [
      "Être majeur(e) (18 ans ou plus)",
      "Étudiant(e) en informatique ou développeur(se) autodidacte",
      "Bonne connaissance de JavaScript / TypeScript",
      "Expérience avec React et Next.js",
      "Maîtrise de Git"
    ],
    skills: {
      required: [
        "JavaScript",
        "TypeScript",
        "React",
        "Next.js"
      ],
      preferred: [
        "Node.js",
        "Bases de données (SQL / NoSQL)",
        "Tailwind CSS",
        "CI/CD"
      ]
    }
  },
  {
    id: 'developpeur-mobile-flutter',
    title: 'Développeur(se) Mobile Flutter',
    department: 'Technique',
    type: 'Bénévole',
    location: 'Remote',
    commitment: '8-10 heures par semaine',
    description: "Nous recherchons des développeur(se)s mobile Flutter pour concevoir et développer les applications iOS et Android de nos offres IA et VPN destinées aux étudiants.",
    responsibilities: [
      "Développer les applications mobiles de nos offres IA et VPN avec Flutter",
      "Intégrer les API et services backend de l'association",
      "Concevoir des interfaces fluides et accessibles en lien avec les designers",
      "Publier et maintenir les applications sur l'App Store et le Google Play Store",
      "Garantir la qualité du code (revues de code, tests)"
    ],
    requirements: [
      "Être majeur(e) (18 ans ou plus)",
      "Étudiant(e) en informatique ou développeur(se) autodidacte",
      "Bonne connaissance de Dart et Flutter",
      "Une première expérience sur une application mobile (projet perso, scolaire ou pro)",
      "Maîtrise de Git"
    ],
    skills: {
      required: [
        "Flutter",
        "Dart",
        "Intégration d'API REST",
        "Gestion d'état (Riverpod, Bloc ou Provider)"
      ],
      preferred: [
        "Publication App Store / Google Play",
        "Firebase",
        "Notions de réseau / VPN (WireGuard)",
        "Intégration d'API d'IA (LLM)"
      ]
    }
  },
  {
    id: 'designer-graphique',
    title: 'Designer Graphique',
    department: 'Design',
    type: 'Bénévole',
    location: 'Remote',
    commitment: '5-8 heures par semaine',
    description: "Nous recherchons un(e) designer créatif(ve) pour réaliser les supports visuels de l'association et renforcer notre identité graphique.",
    responsibilities: [
      "Créer des visuels pour les réseaux sociaux et le site web",
      "Concevoir des supports de communication (affiches, flyers, présentations)",
      "Participer à l'évolution de l'identité visuelle de l'association",
      "Collaborer avec les équipes projet et technique sur les maquettes",
      "Assurer la cohérence graphique sur l'ensemble des supports"
    ],
    requirements: [
      "Être majeur(e) (18 ans ou plus)",
      "Étudiant(e) en design graphique, arts appliqués ou domaine connexe",
      "Maîtrise de Canva",
      "Maîtrise de la suite Adobe (Photoshop, Illustrator, InDesign)",
      "Un portfolio présentant vos réalisations"
    ],
    skills: {
      required: [
        "Canva",
        "Adobe Photoshop",
        "Adobe Illustrator",
        "Design Graphique"
      ],
      preferred: [
        "Adobe InDesign",
        "Figma",
        "Motion Design",
        "Montage Vidéo"
      ]
    }
  },
  {
    id: 'charge-partenariat',
    title: 'Chargé(e) de Partenariat',
    department: 'Marketing',
    type: 'Bénévole',
    location: 'Hybride',
    commitment: '10-12 heures par semaine',
    description: "Nous cherchons un(e) chargé(e) de partenariat dynamique pour développer et maintenir des relations durables avec nos partenaires institutionnels et privés.",
    responsibilities: [
      "Identifier et contacter des partenaires potentiels",
      "Négocier et établir des partenariats",
      "Gérer les relations avec les partenaires existants",
      "Organiser des événements de networking",
      "Suivre et reporter les résultats des partenariats"
    ],
    requirements: [
      "Être majeur(e) (18 ans ou plus)",
      "Étudiant(e) en école de commerce ou université",
      "Excellent relationnel",
      "Capacités de négociation",
      "Maîtrise de la suite Office"
    ],
    skills: {
      required: [
        "Communication",
        "Négociation",
        "Gestion de Projet",
        "CRM"
      ],
      preferred: [
        "Expérience associative",
        "Connaissance du secteur EdTech",
        "LinkedIn Sales Navigator",
        "Analyse de données"
      ]
    }
  }
];

export const getJobById = (id: string): Job | undefined => {
  return jobs.find(job => job.id === id);
};
